<template lang="html">
  <div class="LeaderBoard">
      <img src="./images/header.png" class="title"/>
      <ul class="wrapper" v-if="!!dataList.length">
        <li v-for="item in luckyRankingList" class="item">
          <img class="header" :src="item.photo" width="45" height="45"/>
          <i class="queen" v-if="item.tagBuilder === 'builder'"></i>
          <div class="info">
              <div class="container">
                <h3 class="nickName">
                  <span class="name">{{item.nickName}}</span>
                  <span
                    class="tag"
                    :class="{'bigNow': (item.tagBig === 'nowBig'), 'biggest': (item.tagBig === 'big'), 'builder': (item.tagBuilder === 'builder'), 'newGay': (item.identification === 'YesNewApp')}"
                  ></span>
                </h3>
                <p>
                  <span class="text" v-if="item.tagActive === 'not_active'">{{getElepsedTime(teamCreateTime)}}成功建团</span>
                  <span class="text" v-if="item.tagActive !== 'not_active'">{{getElepsedTime(item.modifyTime)}}{{contents.rankActiveText}}</span>
                  <span class="money">{{Number(item.rewardAmount) / 100 || ''}}<span class="unit">{{item.rewardIcon}}</span></span>
                </p>
              </div>
          </div>
        </li>
      </ul>
      <div class="noPerson" v-else>
        暂无好友激活红包
      </div>
      <div class="more" v-on:click="showAll = true" v-if="!showAll && dataList.length > 0" clstag="jr|keycount|zy|ck">查看更多</div>
  </div>
</template>

<script>
export default {
  name: 'LeaderBoard',
  props: ['dataList', 'teamCreateTime'],
  data(){
    return {
      showAll: false,
      contents: window.contentData.contents || {},
    }
  },
  computed: {
    luckyRankingList () {
      let dataList = this.dataList

      if (dataList.length < 3) {
        this.showAll = true
      }
      if (this.showAll) return dataList

      return dataList.slice(0, 2)
    }
  },
  methods: {
    getElepsedTime (time) {
      let elepsed = 0
      let timeDate = new Date()
      try {
        timeDate.setTime(time)
        let timeStamp = +timeDate
        let now = +new Date()
        elepsed = Math.round((now - timeStamp) / (60 * 1000))
      } catch (e) {
        elepsed = ''
      }
      if (!elepsed) return ''

      let str = elepsed + '分钟之前'
      if (elepsed > 60) {
        let date = timeDate.getDate()
        let hh = timeDate.getHours()
        str = `在${date}日${hh}时`
      }
      return str
    },
    showMoreData(){
      this.showMore = false
    }
  },
}
</script>

<style lang="scss" scoped>
.LeaderBoard{
  margin: 35px auto 50px;

  .title{
    width: 151px;
    height: 19px;
    display: block;
    margin: 0 auto 25px;
  }
  .item{
    height: 77px;
    padding: 0px 16px;
    position: relative;
    display: flex;
    display: -webkit-flex;
    align-items:center;
    -webkit-align-items: center;

    .header{
      border-radius: 100%;
    }
    .queen{
      position: absolute;
      top: -3px;
      left: 18px;
      width: 30px;
      height: 30px;
      background-image: url(./images/queen.png);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100%;
    }

    .info{
      width: 286px;
      flex: 1;
      -webkit-flex: 1;
      margin-left: 12px;
      border-bottom: 1px solid #E3E3E3;
      height: 100%;
      display: flex;
      display: -webkit-flex;
      align-items:center;
      -webkit-align-items: center;
    }
    .container{
      width: 100%;
    }
    .nickName{
      margin-bottom: 3.6px;
      overflow: hidden;

      .name{
        float: left;
        margin-right: 5px;
        height: 22.5px;
        line-height: 22.5px;
        // padding: 3.25px 0px;
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        color: #333333;
      }

      .tag{
        float: left;
        width: 51px;
        height: 22.5px;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 16px;
      }
      .bigNow{
        width: 53px;
        background-image: url(./images/big_now.png);
      }
      .biggest{
        width: 51px;
        background-image: url(./images/big_bag.png);
      }
      .builder{
        width: 63px;
        background-image: url(./images/builder_bag.png);
      }
      .newGay{
        width: 65px;
        background-image: url(./images/new_gay.png);
      }
    }
    .text{
      font-family: 'PingFang-SC-Regular';
      font-size: 13px;
      color: #333333;
    }
    .money{
      font-family: 'PingFangSC-Semibold';
      font-size: 18px;
      color: #FC5829;
      float: right;
    }
    .unit{
      font-size: 12px;
      padding-right: 5px;
    }
  }

  .noPerson{
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    padding-top: 7px;
  }
  .more{
    font-family: PingFang-SC-Regular;
    font-size: 14px;
    color: #333333;
    text-align: center;
    line-height: 20px;
    margin-top: 51px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leaderBoard/index.vue